export default __webpack_public_path__ + "static/media/zaddons_logo.fd960105.png";